import React, {Fragment} from 'react';
import FootballEventCell from "../components/FootballEventCell";
import {getDateString, getNewDate} from "../Utils";
import {Table, Paper, TableCell, TableRow, TableBody, TableContainer} from "@mui/material";

function cellClass(row) {
    return '';
}

function scoresSort(a,b) {
    const aFinal = (a.started === 1 && a.timeLeft === 0);
    const bFinal = (b.started === 1 && b.timeLeft === 0);

    if (aFinal !== bFinal)
        return aFinal ? 1 : -1;

    if (a.started !== b.started) {
        if (a.inProgress !== b.inProgress) {
            return a.inProgress ? -1 : 1;
        }
        else {
            return a.started ? -1 : 1;
        }
    }

    if (a.day !== b.day) {
        const aDate = getNewDate(a.day + "-00:00"), bDate = getNewDate(b.day + "-00:00");
        return aDate - bDate;
    }

    return a.team1.localeCompare(b.team1);
}

function dayFormat(day) {
    return getDateString(day);
}

export default function ScoresTable(scoresData, notificationSupport, onNotificationUpdate, configData) {
    return (
        <Fragment>
            <div>
                <h4>Scores</h4>
                <TableContainer component={Paper} className="BBAuctionScoresTableContainer">
                    <Table size="small">
                        <TableBody>
                            {scoresData
                                .sort(scoresSort)
                                .map((row) => (
                                    <TableRow key={`FootballScoresRow${row.ID}`}>
                                        <TableCell className={cellClass(row)}>
                                            <FootballEventCell
                                                team1={`${row.seed1} ${row.team1} $${row.price1}`}
                                                team2={`${row.seed2} ${row.team2} $${row.price2}`}
                                                score1={row.score1}
                                                score2={row.score2}
                                                team1Color={row.color1}
                                                team2Color={row.color2}
                                                team1Class={configData.Color === row.color1 ? 'MyPickFont' : ''}
                                                team2Class={configData.Color === row.color2 ? 'MyPickFont' : ''}
                                                started={!!row.started}
                                                inProgress={!!row.inProgress}
                                                status={!!row.started ? row.status : null}
                                                picksWinning={row.picks_winning}
                                                picksLosing={row.picks_losing}
                                                statusNote={row.statusNote}
                                                possession={row.possession}
                                                notificationSupport={notificationSupport}
                                                notifications={row.notifications}
                                                day={row.day}
                                                dayFormat={dayFormat}
                                                onNotificationUpdate={onNotificationUpdate}
                                                eventId={Number(row.ID)}
                                                tv={row.tv}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </Fragment>
    );
}
